/**
* Generated automatically at built-time (2025-05-02T09:47:40.931Z).
* DO NOT CHANGE IT, it will be automatically overwritten with each build.
*/
import { createLazyTemplateItem } from "../utils";
import { mergeTemplateItems } from "../common/utils";
export default function Template (props){
const defaultTemplate = [...props.widgets];
return mergeTemplateItems(defaultTemplate, props.templates).map(createLazyTemplateItem);
}
Template.mapValueToTemplateProps = {pageKey: "3D-tyokalu-ulkokeittio",templateKey: "sites/106-139c9416-2784-4390-890f-1ffdcdfe48ff"};